export const GET_HOSPITAL_DATA = "get/hospital/data";

export const SET_HOSPITALS_DETAILS = "set/hospitals/details";

export const IS_BOOKMARK_TABLE = "IS_BOOKMARK_TABLE";

export const GLOBAL_SEARCH_RESET = "GLOBAL_SEARCH_RESET";

export const VIEW = "VIEW";

export const ADD_PROVIDER_NUMBERS = "ADD_PROVIDER_NUMBERS";
export const CLEAR_PROVIDER_NUMBERS = "CLEAR_PROVIDER_NUMBERS";

export const TRIGGER_DATA_REFETCH = "TRIGGER_DATA_REFETCH";

export const SET_TABLE_RESETTING = "SET_TABLE_RESETTING";

export const RESTORE_STATE_SNAPSHOT = "RESTORE_STATE_SNAPSHOT";